import React from 'react'

export default function SectionTitle(props) {
    return (
        <div class={`text-center`}>
            <h6 class="title-upper">{props.upper}</h6>
            <h2 class="title-main mb-2">
               {props.lower}
            </h2>
            {props.text ? (
            <p class="mb-5 small-ttl">
               {props.text}
            </p>
            ) : (
                ""
              )
        }
    </div>
    )
}

